import { useTheme } from "@emotion/react";
import {
  DialogTitle,
  Grid,
  IconButton,
  Icon,
  DialogContent,
  DialogActions,
  DialogContentText,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { DateRangePicker } from "react-date-range";

export function DateCreatedCalendar({
  setOpenDateCreatedCalendar,
  handleDateCreated,
  dateCreatedState,
  setDateCreatedState,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginTop: "10px", marginRight: "10px" }}>
          <IconButton
            size="small"
            onClick={() => setOpenDateCreatedCalendar(false)}
          >
            <Icon>close</Icon>
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              handleDateCreated();
              setOpenDateCreatedCalendar(false);
            }}
          >
            <Icon>search</Icon>
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent>
        <DialogContentText>
          <Grid item md={2}>
            <>
              <DateRangePicker
                onChange={(item) => setDateCreatedState([item.selection])}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={isSmallScreen ? 1 : 2}
                ranges={dateCreatedState}
                direction={isSmallScreen ? "vertical" : "horizontal"}
                preventSnapRefocus={true}
                calendarFocus="backwards"
              />
            </>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions />
    </>
  );
}
